import React from 'react'
import Header from './component/Header/Header'
import Footer from './component/Footer/Footer'

export default function Layout({ children, isSuperAdmin }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Header isSuperAdmin={isSuperAdmin} />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  )
}
